import { currentLocale } from './dates';

/**
 * The business's own currency, set once it is known (see useBrand in
 * Brand.tsx). Defaults to AUD so a page rendered before that arrives, or for
 * a business with none set, reads as it always has.
 */
let currency = 'AUD';
export const setCurrency = (c: string) => {
  currency = /^[A-Z]{3}$/.test(c) ? c : 'AUD';
};

/** An amount in the business's own currency, e.g. "$45.00" or "−$45.00". */
export function formatMoney(v: number | string): string {
  const n = typeof v === 'string' ? Number(v) : v;
  if (!Number.isFinite(n)) return '';
  try {
    const formatted = new Intl.NumberFormat(currentLocale(), {
      style: 'currency',
      currency,
    }).format(n);
    // Intl renders a loss with a plain hyphen; a real minus sign reads better.
    return n < 0 ? formatted.replace('-', '−') : formatted;
  } catch {
    return `${currency} ${n.toFixed(2)}`;
  }
}
